import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  Container,
  DiagnosisContainer,
  Title,
  Description,
  Button,
  ContentsTitle,
  ContentsTitleSmall,
  QuestionTitle,
} from '../Common/Common.style';
import SingleChecker from '../Common/SingleChecker/SingleChecker';
import MultipleChecker from '../Common/MultipleChecker/MultipleChecker';
import RangeSlider from '../Common/RangeSlider/RangeSlider';
import DiagnosisStep from '../DiagnosisStep/DiagnosisStep';
import ImageSlider from '../Common/ImageSlider/ImageSlider';

import { saveSublimicStylistDiagnosis } from '../../../../redux/actions/sublimicDiagnosis';
import { setScalpCameraPinCode } from '../../../../redux/actions/scalpCameraDiagnosis';
import { saveSublimicUserSurvey } from '../../../../redux/actions/sublimicDiagnosis';

import { resetDiagnosisResult } from '../../../../redux/actions/diagnosisResult'

import {
  ErrorMessage,
  SingleCheckerWrapCol3,
} from './StylistDiagnosisPage.style';
import Placeholder from '../../../../components/Placeholder';

class StylistDiagnosisPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validationError: false,
      isDataLoaded: false,
      isLoadResult: false,
      errorRequired: {},
      damagelevel: -1,
      result: {
        treatments: {
          slug: '',
          answers: [],
        },
        hairDiagnosis: {
          hearing: {
            questions: [],
          },
          stylistDiagnosis: {
            questions: [],
          },
        },
        scalpDiagnosis: {
          hearing: {
            questions: [],
          },
          stylistDiagnosis: {
            questions: [],
          },
        },
      },
    };

    // ストレージからstylistDiagnosisResultsを再現
    const stylistDiagnosisResults = JSON.parse(localStorage.getItem('storeStylistDiagnosisResults'));
    if (stylistDiagnosisResults && stylistDiagnosisResults.result) {
      // console.log('ストレージからstylistDiagnosisResultsを再現', stylistDiagnosisResults);  
      this.props.saveSublimicStylistDiagnosis(stylistDiagnosisResults.result);
    }
    // ストレージからpinCodeを再現
    const pinCode = JSON.parse(localStorage.getItem('storePinCode'));
    if (pinCode) {
      // console.log('ストレージからpinCodeを再現', pinCode);  
      this.props.setScalpCameraPinCode(pinCode);
    }
    // ストレージからuserSurveyResultを再現
    const userSurveyResult = JSON.parse(localStorage.getItem('storeUserSurveyResult'));
    if (userSurveyResult && userSurveyResult.result) {
      // console.log('ストレージからuserSurveyResultを再現', userSurveyResult);  
      this.props.saveSublimicUserSurvey(userSurveyResult.result);
    }
  }

  componentWillMount() {
    // スタイリスト診断の質問内容を取得し、ローカル state にキャッシュする
    this.setData();
  }

  componentDidMount() {
    // キャッシュされたデータを描画用に整形する
    if (JSON.parse(localStorage.getItem('storeStylistDiagnosisResults'))) {
      this.setResult();
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    // キャッシュされたデータを画面に描画する目的 (診断結果画面で戻るボタンを押下した時の対応)
    return nextState !== this.state;
  }

  getQuestionsForState = data => {
    const questions = [];
    data.questions.map(question => {
      questions.push({
        slug: question.slug,
        answers: [],
      });
      return {}; // for lint
    });
    return questions;
  };

  /**
   * コンポーネント描画前に呼ばれる
   *   目的: スタイリスト診断の質問内容を取得し、ローカル state にキャッシュする
   */
  setData = () => {
    const { stylistDiagnosis } = this.props;
    const { treatments, hairDiagnosis, scalpDiagnosis } = stylistDiagnosis;
    if (!treatments || this.state.isDataLoaded) return;
    // 1. treatment
    const treatmentsData = {};
    treatmentsData.slug = treatments[0].slug;
    treatmentsData.answers = [];
    // 2. hairDiagnosis.hearing
    const hairHearingQuestions = this.getQuestionsForState(hairDiagnosis.hearing);
    // 3. hairDiagnosis.stylistDiagnosis
    const hairStylistQuestions = this.getQuestionsForState(hairDiagnosis.stylistDiagnosis);
    // 4. scalpDiagnosis.hearing
    const scalpHearingQuestions = this.getQuestionsForState(scalpDiagnosis.hearing);
    // 5. scalpDiagnosis.hearing
    const scalpStylistQuestions = this.getQuestionsForState(scalpDiagnosis.stylistDiagnosis);

    const newResult = {
      treatments: treatmentsData,
      hairDiagnosis: {
        hearing: hairHearingQuestions,
        stylistDiagnosis: hairStylistQuestions,
      },
      scalpDiagnosis: {
        hearing: scalpHearingQuestions,
        stylistDiagnosis: scalpStylistQuestions,
      },
    };
    this.setState({
      isDataLoaded: true,
      result: newResult,
    });
  };

  findQuestion = (slug, questions) => {
    return  questions.find(question => question.slug === slug);
  };

  getQuestionAnswer = (question, Questions) => {
    let foundQuestion = Questions.find(q => question.slug === q.slug);
    let questionAnswer = {...question};
    if(foundQuestion && foundQuestion.slug) {
      questionAnswer.answers = foundQuestion.answers;
      this.checkedAnswer(foundQuestion.answers, question);
      if(foundQuestion.slug === "fq-damagelevel") {
        if(foundQuestion.answers.length > 0) {
          let damagelevelSlug = foundQuestion.answers[0];
          const { stylistDiagnosis } = this.props;
          const { hairDiagnosis } = stylistDiagnosis;
          if(stylistDiagnosis && hairDiagnosis && hairDiagnosis.stylistDiagnosis) {
            let foundDamagelevel = hairDiagnosis.stylistDiagnosis.questions.find(q => q.slug == 'fq-damagelevel');
            if(foundDamagelevel && foundDamagelevel.answers) {
              let damageLevel = foundDamagelevel.answers.findIndex(a => a.slug == damagelevelSlug);
              damageLevel>=0 && this.setState({damageLevel});
            }
          }

        }
      }
    }
    return questionAnswer;
  };

  checkedAnswer = (answers, question) => {
    answers.map(answerSlug => {
      let elementMultiple = document.getElementById(answerSlug);
      let elementSingle = document.getElementById(`a${answerSlug}_${question.slug}`);
      elementMultiple && (elementMultiple.checked = true);
      elementSingle && (elementSingle.checked = true);
    });
  };

  setResult = () => {
    const { sublimicDiagnosis } = this.props;
    const { isDataLoaded, isLoadResult,  result } = this.state;
    if (!isDataLoaded || isLoadResult) return;
    if(sublimicDiagnosis.stylistDiagnosisResults &&
      sublimicDiagnosis.stylistDiagnosisResults.result &&
      Object.keys(sublimicDiagnosis.stylistDiagnosisResults.result).length !== 0 &&
      sublimicDiagnosis.stylistDiagnosisResults.result.constructor === Object) {
      const sublimicDiagnosiStylistDiagnosisResult = sublimicDiagnosis.stylistDiagnosisResults.result;
      const { treatments, hairDiagnosis, scalpDiagnosis } = sublimicDiagnosiStylistDiagnosisResult;
      // 1. treatment
      let treatmentsData = result.treatments;
      if(treatments && treatments.answers && treatments.answers.length > 0){
        treatmentsData.answers = treatments.answers;
        this.checkedAnswer(treatmentsData.answers , {slug: result.treatments.slug});
      }
      // 2. hairDiagnosis.hearing
      const hairHearingQuestions = hairDiagnosis && hairDiagnosis.hearing ? result.hairDiagnosis.hearing.map(question => this.getQuestionAnswer(question, hairDiagnosis.hearing.Questions)) : result.hairDiagnosis.hearing;
      // 3. hairDiagnosis.stylistDiagnosis
      const hairStylistQuestions = hairDiagnosis && hairDiagnosis.stylistDiagnosis ? result.hairDiagnosis.stylistDiagnosis.map(question => this.getQuestionAnswer(question, hairDiagnosis.stylistDiagnosis.Questions)) : result.hairDiagnosis.stylistDiagnosis;
      // 4. scalpDiagnosis.hearing
      const scalpHearingQuestions = scalpDiagnosis && scalpDiagnosis.hearing ? result.scalpDiagnosis.hearing.map(question => this.getQuestionAnswer(question, scalpDiagnosis.hearing.Questions)) : result.scalpDiagnosis.hearing;
      // 5. scalpDiagnosis.hearing
      const scalpStylistQuestions = scalpDiagnosis && scalpDiagnosis.stylistDiagnosis ? result.scalpDiagnosis.stylistDiagnosis.map(question => this.getQuestionAnswer(question, scalpDiagnosis.stylistDiagnosis.Questions)) : result.scalpDiagnosis.stylistDiagnosis;

      const newResult = {
        treatments: treatmentsData,
        hairDiagnosis: {
          hearing: hairHearingQuestions,
          stylistDiagnosis: hairStylistQuestions,
        },
        scalpDiagnosis: {
          hearing: scalpHearingQuestions,
          stylistDiagnosis: scalpStylistQuestions,
        },
      };
      this.setState({
        isLoadResult: true,
        result: newResult,
      });
    }
  };

  questionsToInputDataObj = questions => {
    const slugs = [];
    questions.map(question => {
      slugs.push({
        slug: question.slug,
        values: [],
      });
      return true;
    });
    return slugs;
  };

  findQuestionsByState = slug => {
    const { result } = this.state;
    let obj;
    Object.keys(result).forEach(key => {
      if (result[key].slug) {
        if (result[key].slug === slug) {
          obj = result[key];
          return true;
        }
      } else {
        Object.keys(result[key]).forEach(k => {
          for (let i = 0; i < result[key][k].length; i++ ) {
            if (result[key][k][i].slug === slug) {
              obj = result[key][k][i];
            }
          }
        });
      }
    });
    return obj;
  };

  getAnswersBySlug = slug => {
    const { result } = this.state;
    let answers;
    Object.keys(result).some(key => {
      if (result[key].slug) {
        if (result[key].slug === slug && result[key].answers) {
          answers = result[key].answers;
          return true;
        }
      } else {
        Object.keys(result[key]).some(k => {
          console.log(slug, result[key][k]);
          if (result[key][k].slug === slug && result[key][k].answers) {
            answers = result[key][k].answers;
            return true;
          }
        });
      }
    });
    return answers;
  };

  handleChecked = (e, question, answer) => {
    const answersObj = this.findQuestionsByState(question.slug);

    if (!question.multipleAnswer) {
      answersObj.answers = [];
    }

    if (e && e.target && e.target.checked) {
      answersObj.answers.push(answer.slug);
    } else {
      const answerIndex = answersObj.answers.findIndex(value => value === answer.slug);
      answersObj.answers.splice(answerIndex, 1);
    }

    if(question.slug === "fq-damagelevel"){
      answersObj.answers = [];
      answersObj.answers.push(answer.slug);
    }
  };

  handleInput = (e, parentQuestion) => {

  };

  finishDiagnosis = () => {
    if (this.validate()) {
      const { history, saveSublimicStylistDiagnosis, resetDiagnosisResult } = this.props;
      resetDiagnosisResult();
      let { result } = this.state;

      // questionsが抜けていたので暫定対処
      const newResult = {
        treatments: result.treatments,
        hairDiagnosis: {
          hearing: {
            Questions: result.hairDiagnosis.hearing,
          },
          stylistDiagnosis: {
            Questions: result.hairDiagnosis.stylistDiagnosis,
          },
        },
        scalpDiagnosis: {
          hearing: {
            Questions: result.scalpDiagnosis.hearing,
          },
          stylistDiagnosis: {
            Questions: result.scalpDiagnosis.stylistDiagnosis,
          },
        },
      };
      saveSublimicStylistDiagnosis(newResult);

      if (newResult) {
        // ストレージにstylistDiagnosisResultsを保存
        const stylistDiagnosisResults = { result: newResult }
        // console.log('ストレージにstylistDiagnosisResultsを保存', stylistDiagnosisResults);
        localStorage.setItem('storeStylistDiagnosisResults', JSON.stringify(stylistDiagnosisResults));
      }

      history.push(`./result/top`);
    } else {
      this.setState({ validationError: true });
    }
  };

  useCamera = () => {
    const { authSalonSettings } = this.props;
    if (authSalonSettings && authSalonSettings.others && authSalonSettings.others.useCamera) {
      return authSalonSettings.others.useCamera.toLowerCase() === 'true' ? true : false;
    }
    return false;
  };

  validate = () => {
    const { stylistDiagnosis } = this.props;
    const { treatments, hairDiagnosis, scalpDiagnosis } = stylistDiagnosis;
    const { result } = this.state;
    let error = {};

    // 0: Treatments
    treatments.forEach(question => {
      const inputValue = this.findQuestionsByState(question.slug);
      const required = question.validationTypes.find(type => type === 'Required');
      if (required !== -1) {
        if (inputValue.answers.length === 0) {
          error[question.slug] = true;
        }
      }
    });

    // 1: HairDiagnosis.hearing
    hairDiagnosis.hearing.questions.forEach(question => {
      const inputValue = this.findQuestionsByState(question.slug);
      const required = question.validationTypes && question.validationTypes.find(type => type === 'Required');
      if (required !== undefined) {
        if (inputValue.answers.length === 0) {
          error[question.slug] = true;
        }
      }
    });

    // 2: HairDiagnosis.stylistDiagnosis
    hairDiagnosis.stylistDiagnosis.questions.forEach(question => {
      const inputValue = this.findQuestionsByState(question.slug);
      const required = question.validationTypes && question.validationTypes.find(type => type === 'Required');
      if (required !== undefined) {
        if (inputValue.answers.length === 0) {
          error[question.slug] = true;
        }
      }
    });

    // 3: ScalpDiagnosis.hearing
    scalpDiagnosis.hearing.questions.forEach(question => {
      const inputValue = this.findQuestionsByState(question.slug);
      const required = question.validationTypes && question.validationTypes.find(type => type === 'Required');
      if (required !== undefined) {
        if (inputValue.answers.length === 0) {
          error[question.slug] = true;
        }
      }
    });

    // 4: ScalpDiagnosis.stylistDiagnosis
    scalpDiagnosis.stylistDiagnosis.questions.forEach(question => {
      const inputValue = this.findQuestionsByState(question.slug);
      const required = question.validationTypes && question.validationTypes.find(type => type === 'Required');
      if (required !== undefined) {
        if (inputValue.answers.length === 0) {
          error[question.slug] = true;
        }
      }
    });
    this.setState({ errorRequired: error });
    return Object.keys(error).length > 0 ? false : true;
  };

  getDiagnosisStep = () => {
    // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
    // const useCamera = !!this.useCamera();
    const skippedUserSurvey = !!localStorage.getItem('sublimic-skippedUserSurvey');
    let pageNumber = 1;
    let maxNumber = 1;

    // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
    // if (useCamera && !skippedUserSurvey) {
    //   pageNumber = 3;
    //   maxNumber = 3;
    // } else if (useCamera && skippedUserSurvey) {
    //   pageNumber = 2;
    //   maxNumber = 2;
    // } else if (!useCamera && !skippedUserSurvey) {
    //   pageNumber = 2;
    //   maxNumber = 2;
    // } else if (!useCamera && skippedUserSurvey) {
    //   pageNumber = 1;
    //   maxNumber = 1;
    // }

    if (!skippedUserSurvey) {
      pageNumber = 2;
      maxNumber = 2;
    } else {
      pageNumber = 1;
      maxNumber = 1;
    }

    return maxNumber > 1 ? <DiagnosisStep pageNumber={pageNumber} maxNumber={maxNumber} /> : null;
  };

  render() {
    const { stylistDiagnosis, copy, scalpCamera, scalpCameraDiagnosisResult } = this.props;
    const { title, description, treatments, hairDiagnosis, scalpDiagnosis } = stylistDiagnosis;
    const { errorRequired, validationError, damageLevel } = this.state;

    const commonCopy = copy.common || {};
    const ownCopy = copy.sublimicDiagnosis || {};

    const scalpCameraImage = scalpCameraDiagnosisResult.diagnosisResults.success && scalpCameraDiagnosisResult.diagnosisResults.imageUrl || false;

    return (
      <Container>
        {this.getDiagnosisStep()}
        <DiagnosisContainer>
          <Title>{title}</Title>
          <Description>{description}</Description>
          {treatments &&
          treatments.map(treatment => (
            <div key={treatment.entryId}>
              <QuestionTitle>{treatment.title}</QuestionTitle>
              <MultipleChecker question={treatment} handleChecked={this.handleChecked} handleInput={this.handleInput} />
              {errorRequired[treatment.slug] ? <ErrorMessage>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
            </div>
          ))}
          <ContentsTitle>{hairDiagnosis && hairDiagnosis.title}</ContentsTitle>
          <ContentsTitleSmall>{hairDiagnosis && hairDiagnosis.hearing.title}</ContentsTitleSmall>
          {hairDiagnosis &&
          hairDiagnosis.hearing.questions.map(question => (
            <React.Fragment key={question.entryId}>
              <QuestionTitle>{question.title}</QuestionTitle>
              {(() => {
                if (question.answers) {
                  if (question.multipleAnswer) {
                    return (
                      <MultipleChecker
                        question={question}
                        handleChecked={this.handleChecked}
                        handleInput={this.handleInput}
                      />
                    );
                  } else if (!question.multipleAnswer) {
                    return (
                      <SingleChecker question={question} handleChecked={this.handleChecked} handleInput={this.handleInput} key={question.entryId} />
                    );
                  }
                }
              })()}
              {errorRequired[question.slug] ? <ErrorMessage className={!question.multipleAnswer && 'after-single-checker'}>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
            </React.Fragment>
          ))}

          <ContentsTitleSmall>{hairDiagnosis && hairDiagnosis.stylistDiagnosis.title}</ContentsTitleSmall>
          {hairDiagnosis &&
          hairDiagnosis.stylistDiagnosis.questions.map(question => (
            <React.Fragment key={question.entryId}>
              <QuestionTitle>{question.title}</QuestionTitle>
              {(() => {
                if (question.slug === "fq-damagelevel") {
                  return (
                    <RangeSlider copy={ownCopy} question={question} damageLevel={damageLevel} handleChecked={this.handleChecked} />
                  );
                }
                if (question.answers) {
                  if (question.multipleAnswer) {
                    return (
                      <MultipleChecker
                        question={question}
                        handleChecked={this.handleChecked}
                        handleInput={this.handleInput}
                      />
                    );
                  } else if (!question.multipleAnswer) {
                    return (
                      <SingleChecker question={question} handleChecked={this.handleChecked} handleInput={this.handleInput} />
                    );
                  }
                }
              })()}
              {errorRequired[question.slug] ? <ErrorMessage className={!question.multipleAnswer && 'after-single-checker'}>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
            </React.Fragment>
          ))}
          <ContentsTitle>{scalpDiagnosis && scalpDiagnosis.title}</ContentsTitle>
          <ContentsTitleSmall>{scalpDiagnosis && scalpDiagnosis.hearing.title}</ContentsTitleSmall>
          {scalpDiagnosis &&
          scalpDiagnosis.hearing.questions.map(question => (
            <React.Fragment key={question.entryId}>
              <QuestionTitle>{question.title}</QuestionTitle>
              {(() => {
                if (question.answers) {
                  if (question.multipleAnswer) {
                    return (
                      <MultipleChecker
                        question={question}
                        handleChecked={this.handleChecked}
                      />
                    );
                  } else if (!question.multipleAnswer) {
                    return (
                      // <SingleCheckerWrapCol3>
                      <SingleChecker
                        question={question}
                        handleChecked={this.handleChecked}
                        handleInput={this.handleInput}
                      />
                      // </SingleCheckerWrapCol3>
                    );
                  }
                }
              })()}
              {errorRequired[question.slug] ? <ErrorMessage className={!question.multipleAnswer && 'after-single-checker'}>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
            </React.Fragment>
          ))}
          <ContentsTitleSmall>{scalpDiagnosis && scalpDiagnosis.stylistDiagnosis.title}</ContentsTitleSmall>
          {!!(scalpDiagnosis && _.get(copy, 'sublimicDiagnosis.sampleButton')) && (<ImageSlider itemList={scalpDiagnosis.stylistDiagnosis.sampleImages} buttonText={copy.sublimicDiagnosis.sampleButton} />)}
          {scalpDiagnosis &&
          scalpDiagnosis.stylistDiagnosis.questions.map(question => (
            <React.Fragment key={question.entryId}>
              <QuestionTitle>{question.title}</QuestionTitle>
              {(() => {
                if (question.answers) {
                  if (question.multipleAnswer) {
                    return (
                      <MultipleChecker
                        question={question}
                        handleChecked={this.handleChecked}
                        handleInput={this.handleInput}
                      />
                    );
                  } else if (!question.multipleAnswer) {
                    return (
                      <SingleCheckerWrapCol3>
                        <SingleChecker
                          question={question}
                          handleChecked={this.handleChecked}
                          handleInput={this.handleInput}
                        />
                      </SingleCheckerWrapCol3>
                    );
                  }
                }
              })()}
              {errorRequired[question.slug] ? <ErrorMessage className={!question.multipleAnswer && 'after-single-checker'}>{copy.errorMessage && copy.errorMessage.inputRequired}</ErrorMessage> : null}
            </React.Fragment>
          ))}

          <Button className='stylistDiagnosis' onClick={this.finishDiagnosis}>{ownCopy.getResultBtn || <Placeholder w="50px" h="16px" />}</Button>
          {validationError ? <ErrorMessage>{ownCopy.errorRequired}</ErrorMessage> : ''}
        </DiagnosisContainer>
      </Container>
    );
  }
}

StylistDiagnosisPage.defaultProps = {
  copy: {},
  scalpCamera: {},
  stylistDiagnosis: {},
  authSalonSettings: {},
};
StylistDiagnosisPage.propTypes = {
  stylistDiagnosis: PropTypes.shape().isRequired,
  copy: PropTypes.shape(),
  authSalonSettings: PropTypes.shape(),
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  sublimicDiagnosis: state.sublimicDiagnosis,
  stylistDiagnosis: state.stylistDiagnosis,
  scalpCamera: state.scalpCamera,
  authSalonSettings: state.authSalonSettings,
  scalpCameraDiagnosisResult: state.scalpCameraDiagnosis,
});

const mapDispatch = dispatch => ({
  resetDiagnosisResult : () => dispatch(resetDiagnosisResult()),
  saveSublimicStylistDiagnosis: data => dispatch(saveSublimicStylistDiagnosis(data)),
  setScalpCameraPinCode: (pin) => dispatch(setScalpCameraPinCode(pin)),
  saveSublimicUserSurvey: data => dispatch(saveSublimicUserSurvey(data)),
});
export default connect(mapState, mapDispatch)(StylistDiagnosisPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/StylistDiagnosisPage/StylistDiagnosisPage.js